export const validatePatientInitials = (value: string): string | null => {
  if (value.length === 0) {
    // Allow clearing the input
    return '';
  }

  const firstChar = value[0];

  // Check for inconsistent input (e.g., a letter after a digit or vice versa)
  if (
    (/[A-Za-z]/.test(firstChar) && /[^A-Za-z]/.test(value)) || // Letter first, but non-letter entered
    (/[0-9]/.test(firstChar) && /[^0-9]/.test(value)) // Digit first, but non-digit entered
  ) {
    return null;
  }

  if (/[A-Za-z]/.test(firstChar)) {
    // If the first character is a letter, allow only letters and restrict to 3 characters
    const lettersOnly = value.replace(/[^A-Za-z]/g, '').toUpperCase();
    return lettersOnly.length <= 3 ? lettersOnly : null;
  } else if (/[0-9]/.test(firstChar)) {
    // If the first character is a digit, allow only digits and restrict to 10 characters
    const digitsOnly = value.replace(/[^0-9]/g, '');
    return digitsOnly.length <= 10 ? digitsOnly : null;
  } else {
    return null;
  }
};
